import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Oops from "./assets/images/Oops.png";

const Error = () => {
  return (
    <Container>
      <section id="error-page" className="pt-5 px-5">
        <h3 className="mb-5">PAGE NOT FOUND</h3>
        <img src={Oops} alt="Oops emotion" width="150px" className="mb-5" />
        <p>Oops! It looks like you've reached a URL that doesn't exist</p>
        <Link to="/">
          <button>Go back to home</button>
        </Link>
      </section>
    </Container>
  );
};

export default Error;
